import classes from "./HorizontalListViewItem.module.css";
import {Image} from "@mantine/core";
import {ReactNode} from "react";

type ListItemProps = {
    /**
     * Children to be rendered.
     * If string - we're expecting image source.
     * @author Kacper Faber
     * @since 0.1.9
     */
    children: ReactNode | string;

    /**
     * Is item active?
     * @author Kacper Faber
     * @since 0.1.9
     */
    active?: boolean;

    /**
     * On item is clicked
     * @author Kacper Faber
     * @since 0.1.9
     */
    onClick: () => void;
};

function ListItem(props: ListItemProps) {
    /**
     * Get classes for this item
     * @author Kacper Faber
     * @since 0.1.9
    */
    const getClasses = () => {
        return `${classes.root} ${props.active ? classes.active : classes.inactive}`;
    };

    /**
     * Render children
     * @author Kacper Faber
     * @since 0.1.9
     */
    const renderChildren = () => {
        if (props.children satisfies ReactNode) {
            return (
                <>
                    { props.children }
                </>
            );
        }

        return (
            <Image
                w={56}
                h={56}
                src={props.children}
            />
        );
    }

    return (
        <div className={getClasses()} onClick={props.onClick}>
            { renderChildren() }
        </div>
    );
}

export default ListItem;